import { Dispatch, FC, SetStateAction, useState } from 'react';
import { Hr } from 'src/components/_commons';
import { millisecondsOneDay } from '@monorepo/helpers';
import { NotificationsMeetingAVUshers } from './commons/NotificationsMeetingAVUshers';
import { NotificationsSettings } from './commons/NotificationsSettings';
import { NotificationsTitle } from './commons/NotificationsTitle';
import { typeNotificationsDoc, typeMeetingsDoc, typeNotificationSetting, typeUser } from '@monorepo/models';

type propsType = {
    meetingsDoc: typeMeetingsDoc;
    notificationsDoc: typeNotificationsDoc;
    setRefreshCounter: Dispatch<SetStateAction<number>>;
    users: typeUser[];
};

export const NotificationsMeetingsMidweekAvUshers: FC<propsType> = ({
    meetingsDoc, notificationsDoc, setRefreshCounter, users
}) => {
    const [head1Id, setHead1Id] = useState<number | null | undefined>(notificationsDoc.avHeadOfDepartmentId);
    const [head2Id, setHead2Id] = useState<number | null | undefined>(notificationsDoc.usherHeadOfDepartmentId);
    const [newNotificationSettings, setNewNotificationSettings] = useState<typeNotificationSetting[]>(notificationsDoc.midweekAVUshers);
    const meetings = meetingsDoc.midweeks
        .filter(m => new Date(m.date).getTime() > new Date().getTime() - millisecondsOneDay)
        .filter(m => m.avAssignments.filter(a => a.user).length || m.usherAssignments.filter(a => a.user).length)
        .sort((m1, m2) => new Date(m1.date).getTime() - new Date(m2.date).getTime())
    ;
    const type = 'meetings-midweek-av-ushers';

    return (
        <div>
            <NotificationsTitle
                type={type}
            />
            <NotificationsSettings
                head1Id={head1Id}
                head1OriginalId={notificationsDoc.avHeadOfDepartmentId}
                head2Id={head2Id}
                head2OriginalId={notificationsDoc.usherHeadOfDepartmentId }
                notificationsDoc={notificationsDoc}
                notificationSettings={notificationsDoc.midweekAVUshers}
                newNotificationSettings={newNotificationSettings}
                setNewNotificationSettings={setNewNotificationSettings}
                setRefreshCounter={setRefreshCounter}
                type={type}
                updateHead1Id={setHead1Id}
                updateHead2Id={setHead2Id}
                users={users}
            />

            <Hr classes={'my-5'} />

            <NotificationsMeetingAVUshers
                meetings={meetings}
            />
        </div>
    );
}
